import React from 'react';
import {
    Box,
    Heading,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Text,
    Icon,
    Flex
} from '@chakra-ui/react';
import {
    AiOutlineArrowUp,
    AiOutlineArrowDown,
    AiOutlineWarning,
    AiOutlineSortAscending, 
    AiOutlineSortDescending
} from 'react-icons/ai';

const TopErrorsTable = ({ data = [] }) => {
    const [sortConfig, setSortConfig] = React.useState({ key: 'count', direction: 'descending' }); 
    const sortedData = React.useMemo(() => {
        if (!data) return []; 
        return [...data].sort((a, b) => {
            const aValue = a.count || 0;
            const bValue = b.count || 0;
            if (aValue < bValue) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
    }, [data, sortConfig]); 

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return null; 
        return sortConfig.direction === 'ascending' ? AiOutlineSortAscending : AiOutlineSortDescending;
    };

    return (
        <Box
            bg="surface"
            borderRadius="lg"
            p={6}
            border="1px solid"
            borderColor="gray.800"
            height="full" 
            display="flex" 
            flexDirection="column" 
        >
            <Heading as="h3" size="sm" color="white" mb={4}>Top 10 Erros (Mensagens)</Heading>

            {sortedData && sortedData.length > 0 ? (
                <TableContainer flexGrow={1} overflowY="auto"> 
                    <Table variant="simple" size="sm" colorScheme="whiteAlpha">
                        <Thead position="sticky" top={0} bg="surface" zIndex={1}> 
                            <Tr borderBottom="2px solid" borderColor="secondary">
                                <Th color="gray.400" w="50px" textAlign="center">#</Th> 
                                <Th color="gray.400">Mensagem</Th>
                                <Th
                                    color="gray.400"
                                    isNumeric
                                    onClick={() => requestSort('count')} 
                                    cursor="pointer"
                                    w="100px" 
                                >
                                    <Flex align="center" justify="flex-end">
                                        Total <Icon as={getSortIcon('count') || AiOutlineSortDescending} ml={1} />
                                    </Flex>
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {sortedData.map((error, index) => (
                                <Tr
                                    key={index} 
                                    bg={index % 2 === 0 ? 'transparent' : 'gray.800'}
                                    _hover={{ bg: 'gray.700' }}
                                    transition="background-color 0.2s"
                                >
                                    <Td textAlign="center" color="gray.500">{index + 1}</Td>
                                    <Td color="gray.300" fontSize="sm" whiteSpace="pre-wrap" maxW="400px" title={error._id}> 
                                        {error._id}
                                    </Td>
                                    <Td isNumeric color="white" fontWeight="bold">
                                        {(error.count || 0).toLocaleString('pt-BR')}
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </TableContainer>
            ) : (
                 <Flex flexGrow={1} justify="center" align="center">
                    <Text color="gray.500">Nenhum erro encontrado no período.</Text>
                 </Flex>
            )}

            <Text fontSize="xs" color="gray.600" mt={4}>
                *Visualização limitada aos 10 principais erros do período.
            </Text>
        </Box>
    );
};

export default TopErrorsTable;